module.exports = __webpack_public_path__ + "static/img/domain.84917c79.png";